module.exports = __webpack_public_path__ + "img/debt-assist.86cc440f.svg";